import { render } from "./CadastroUsuario.vue?vue&type=template&id=4cfa00fa&scoped=true"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js"

import "./CadastroUsuario.vue?vue&type=style&index=0&id=4cfa00fa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfa00fa"]])

export default __exports__